// export const BASE_URL = 'http://localhost:9493'

export const BASE_URL = "https://prueba.sendcuba.net";
